import React from "react";
import { ReactController } from "../react_controller";
import { PaginatedReportPrimerGrid } from "../../components/grids/ReportGrid/PaginatedReportPrimerGrid";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

export class ReportPrimerGridController extends ReactController {
  connect() {
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <PaginatedReportPrimerGrid {...this.propsValue} />
      </QueryClientProvider>
    );
  }
} 